
import './Spinner.scss';

import LazyLoad from 'react-lazyload'

const Spinner = () => {

  return (
    <div className='loader-wrapper'>
      <LazyLoad>
      <img src={"/assets/images/logo.svg"} alt="" />
      </LazyLoad>
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>

    </div>
  )
}
export default Spinner;
